var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M8 2.5c3.038 0 5.5 2.462 5.5 5.5s-2.462 5.5-5.5 5.5S2.5 11.038 2.5 8 4.962 2.5 8 2.5zM6.436 5.146c-.221 0-.4.18-.4.4v4.913c0 .07.018.138.053.198.11.192.354.258.545.149l4.295-2.459c.062-.035.113-.086.148-.148.11-.192.043-.436-.149-.546L6.634 5.199c-.06-.034-.129-.053-.198-.053z" })
  );
});